import { DomSanitizer, SafeValue } from '@angular/platform-browser';
import { PipeTransform, Pipe, SecurityContext } from '@angular/core';
import DOMPurify from 'isomorphic-dompurify';

@Pipe({
  name: 'safeContent',
  standalone: true,
})
export class SanitizerPipe implements PipeTransform {
  constructor(private readonly domSanitizer: DomSanitizer) {}

  private bypassSecurityTrust(context: SecurityContext, purifiedValue: string): SafeValue | null {
    switch (context) {
      case SecurityContext.HTML:
        return this.domSanitizer.bypassSecurityTrustHtml(purifiedValue);
      case SecurityContext.STYLE:
        return this.domSanitizer.bypassSecurityTrustStyle(purifiedValue);
      case SecurityContext.SCRIPT:
        return this.domSanitizer.bypassSecurityTrustScript(purifiedValue);
      case SecurityContext.URL:
        return this.domSanitizer.bypassSecurityTrustUrl(purifiedValue);
      case SecurityContext.RESOURCE_URL:
        return this.domSanitizer.bypassSecurityTrustResourceUrl(purifiedValue);
      default:
        return null;
    }
  }

  private replaceHtmlTagReferences(value: string): string {
    // <title> is the only tag that requires special handling here.
    // Other stripped tags are removed by DOMPurify with KEEP_CONTENT: true (default)
    // <title> is different: the browser HTML parser itself treats everything between
    // <title> and </title> as non-rendered title text causing all text inside <title> to disappear from the view.
    return value.replace(/<title>/gi, '<code>title</code>').replace(/<\/title>/gi, '');
  }

  public transform(value: string | Node, context: SecurityContext = SecurityContext.HTML): SafeValue | null {
    const processed = typeof value === 'string' ? this.replaceHtmlTagReferences(value) : value;
    return this.bypassSecurityTrust(context, DOMPurify.sanitize(processed));
  }
}
